import { render } from "./TableTeam.vue?vue&type=template&id=d2899f22&scoped=true"
import script from "./TableTeam.vue?vue&type=script&lang=js"
export * from "./TableTeam.vue?vue&type=script&lang=js"

import "./TableTeam.vue?vue&type=style&index=0&id=d2899f22&scoped=true&lang=css"
import "./TableTeam.vue?vue&type=style&index=1&id=d2899f22&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/production-allsports-2/production-as-fe-ASPN/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d2899f22"]])

export default __exports__